<template>
  <div>
  <div v-if="featured" class="col-2">
    <h1>
      <span class="acier">{{ featured.title }}</span>
    </h1>
    <div v-if="featured.ckc_cover_image" ref="cover_image">
      <img :src="featured.ckc_cover_image" alt="" />
    </div>
    <div v-else ref="cover_image">
      <img src="~@/assets/img/default.png" alt="" />
    </div>
    <div
      v-if="featured.text"
      class="text-up"
      v-html="featured.text"
    >
    </div>
  </div>
  <h1>
    Wystawy: <span class="acier">{{ total }}</span>
  </h1>
  </div>
</template>

<script>
import { eventBus } from "@/main.js";
export default {
  name: "ExhibitsHead",
  props: ["total", "featured"],
  mounted() {
    eventBus.$emit("headLoaded");
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/Heads/ExhibitsHead.vue